import EditIdentityIdentifierToggle from './EditIdentityIdentifierToggle';

export default EditIdentityIdentifierToggle;
